import {CONFIG} from '../../../../config';
import qs from 'qs';
import {store} from '@/store';
import {AUTH_GET_TOKEN} from '@/store/modules/authentication/types';
import {ReportsReportViewerEnum} from '@/modules/neodash/model/types/enums/reportsReportViewerEnum';
import AuthService from '@/services/auth.service';

const auth = new AuthService();
const baseUrl: string = `${CONFIG.URL.REPORT_VIEWER}/View/ReportViwerPage.aspx`;

export const getUrlReportViewer = <T>(report: ReportsReportViewerEnum, params: T): string => {
  let parameters = {
    codreport: report,
    ...params,
    client: sessionStorage.getItem('client'),
    vehicle: sessionStorage.getItem('vehicle'),
    //authorization: store.getters[AUTH_GET_TOKEN],
  } as any;

  const exceptions = Object.keys(params)
      .filter(x => typeof params[x] === 'object' && !!params[x]);

  const hasValueOnPropValue = x => params[x].value != undefined && params[x].value != null;

  //treat ITextValue interface
  exceptions
      .filter(hasValueOnPropValue)
      .forEach(x => {
        const value = params[x].value;
        parameters[x] = typeof value === 'object' ? value.join(',') : value;
      });

  exceptions
      .filter(x => !hasValueOnPropValue(x))
      .forEach(x => {
        parameters[x] = params[x].filter(x => !!x.value).map(x => x.value).join(',');
      });

  return `${baseUrl}?${jQuery.param(parameters)}`;
};

